// <cart-discount> — applies a discount code from inside the cart drawer without an app.
// Hits the native /discount/{code} endpoint (sets the cart discount), then re-renders the
// drawer sections via /cart/update.js so cart.cart_level_discount_applications shows up.
if (!customElements.get('cart-discount')) {
  class CartDiscount extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('[data-discount-input]');
      this.applyButton = this.querySelector('[data-discount-apply]');
      this.error = this.querySelector('[data-discount-error]');
      this.cartDrawer = document.querySelector('cart-drawer');

      this.applyButton?.addEventListener('click', () => this.apply());
      this.input?.addEventListener('keydown', event => {
        if (event.key === 'Enter') {
          event.preventDefault();
          this.apply();
        }
      });
    }

    showError(message) {
      if (!this.error) return;
      this.error.textContent = message;
      this.error.hidden = !message;
    }

    async apply() {
      const code = (this.input?.value || '').trim();
      if (!code) return;

      this.showError('');
      this.applyButton.classList.add('disabled');

      try {
        // Sets the discount on the cart (follows the 302 it returns).
        await fetch(`${window.shopUrl || ''}/discount/${encodeURIComponent(code)}`, {
          method: 'GET',
          credentials: 'same-origin'
        });

        const cartDrawer = this.cartDrawer || document.querySelector('cart-drawer');
        const sections = cartDrawer
          ? cartDrawer.getSectionsToRender().map(section => section.section)
          : ['cart-drawer', 'cart-counter'];

        const response = await fetch(`${routes.cart_update_url}`, {
          ...fetchConfig(),
          ...{
            body: JSON.stringify({
              sections,
              sections_url: window.location.pathname
            })
          }
        }).then(r => r.json());

        if (cartDrawer) cartDrawer.renderContents(response, false);
      } catch (error) {
        console.error(error);
        this.showError(
          window.cartStrings?.discountError || 'No se pudo aplicar el código.'
        );
      } finally {
        this.applyButton.classList.remove('disabled');
      }
    }
  }

  customElements.define('cart-discount', CartDiscount);
}
